import {
  FORUM_APP_ID,
  FORUM_SECTION_ID,
} from '@wix/communities-forum-universal/dist/src/constants/appsConfig.prod';
import { getPricingPlansPublicAPI } from '@wix/pricing-plans-tpa-api';

export const navigateToPaidPlans =
  (returnUrl = '', planIds, titleText, buttonText, categoryId) =>
  (dispatch, getState, { wixCodeApi }) => {
    return getPricingPlansPublicAPI(wixCodeApi).then((api) =>
      api.navigateToPricingPage({
        planIds,
        biOptions: {
          referralInfo: 'forum',
          referralId: categoryId,
        },
        checkout: {
          thankYouPage: {
            content: {
              title: titleText,
              cta: buttonText,
            },
            navigation: {
              type: 'section',
              options: {
                sectionId: FORUM_SECTION_ID,
                appDefinitionId: FORUM_APP_ID,
                state: returnUrl,
                shouldRefreshIframe: true,
              },
            },
          },
        },
      }),
    );
  };
